<template>
  <div>
    <v-content>
      <v-layout row wrap align-start>
        <v-flex xs12 md12>
          <h1 class="content-title">Spice Money</h1>
          <h2 class="content-sub-title">Partners / Alliances</h2>

          <h3 class="mb-4">We work with a number of banking partners to deliver our products</h3>
        </v-flex>

        <v-flex xs12 sm4 class="px-4 mb-5 learship-container">
          <div class="leadership-img">
            <div class="bg-circle"></div>
            <div class="grey-circle"></div>
            <img alt="spice money" :src="require('@/assets/images/rbl.png')">
          </div>
          <div style="clear:both"></div>
          <div class="leadership-name">RBL Bank</div>
          <div class="blue-bar"></div>
          <div class="leadership-designation"></div>
        </v-flex>

        <v-flex xs12 sm4 class="px-4 mb-5 learship-container">
          <div class="leadership-img">
            <div class="bg-circle"></div>
            <div class="grey-circle"></div>
            <img alt="spice money" :src="require('@/assets/images/kotak.png')">
          </div>
          <div style="clear:both"></div>
          <div class="leadership-name">Kotak</div>
          <div class="blue-bar"></div>
          <div class="leadership-designation"></div>
        </v-flex>

        <v-flex xs12 sm4 class="px-4 mb-5 learship-container">
          <div class="leadership-img">
            <div class="bg-circle"></div>
            <div class="grey-circle"></div>
            <img alt="spice money" :src="require('@/assets/images/icici.png')">
          </div>
          <div style="clear:both"></div>
          <div class="leadership-name">ICICI Bank</div>
          <div class="blue-bar"></div>
          <div class="leadership-designation"></div>
        </v-flex>

        <v-flex xs12 sm4 class="px-4 mb-5 learship-container">
          <div class="leadership-img">
            <div class="bg-circle"></div>
            <div class="grey-circle"></div>
            <img alt="spice money" :src="require('@/assets/images/yesbank.png')">
          </div>
          <div style="clear:both"></div>
          <div class="leadership-name">Yes Bank</div>
          <div class="blue-bar"></div>
          <div class="leadership-designation"></div>
        </v-flex>

        <v-flex xs12 sm4 class="px-4 mb-5 learship-container">
          <div class="leadership-img">
            <div class="bg-circle"></div>
            <div class="grey-circle"></div>
            <img alt="spice money" :src="require('@/assets/images/indus.png')">
          </div>
          <div style="clear:both"></div>
          <div class="leadership-name">Indusind Bank</div>
          <div class="blue-bar"></div>
          <div class="leadership-designation"></div>
        </v-flex>

        <v-flex xs12 sm4 class="px-4 mb-5 learship-container">
          <div class="leadership-img">
            <div class="bg-circle"></div>
            <div class="grey-circle"></div>
            <img alt="spice money" :src="require('@/assets/images/federal.png')">
          </div>
          <div style="clear:both"></div>
          <div class="leadership-name">Federal Bank</div>
          <div class="blue-bar"></div>
          <div class="leadership-designation"></div>
        </v-flex>

        <v-flex xs12 sm4 class="px-4 mb-5 learship-container">
          <div class="leadership-img">
            <div class="bg-circle"></div>
            <div class="grey-circle"></div>
            <img alt="spice money" :src="require('@/assets/images/sbi.png')">
          </div>
          <div style="clear:both"></div>
          <div class="leadership-name">State Bank of India</div>
          <div class="blue-bar"></div>
          <div class="leadership-designation"></div>
        </v-flex>
      </v-layout>
    </v-content>
  </div>
</template>

<style scoped>
h3 {
  font-weight: normal;
  font-size: 18px;
  font-style: italic;
  padding-bottom: 20px;
}
.content-title {
  color: #ed1c24;
  font-size: 24px;
  font-weight: normal;
  margin: 0;
  padding: 0;
  text-transform: uppercase;
}
.content-sub-title {
  font-size: 42px;
  line-height: 42px;
  text-transform: uppercase;
  color: #293896;
  margin-bottom: 30px;
}
.cursorpointer {
  cursor: pointer;
}
.content-image {
  cursor: crosshair;
}
.box-shadow {
  box-shadow: 0 0 30px #e3e3e3;
  background: #fff;
  padding: 40px 48px;
}
.leadership-img {
  position: relative;
  float: left;
}
.leadership-img img {
  position: relative;
  z-index: 3;
  max-width: 100%;
  float: left;
}
.blue-bar {
  width: 100px;
  height: 3px;
  background: #ed1c24;
  margin: 10px auto;
}
.bg-circle {
  position: absolute;
  border-radius: 50%;
  width: 100%;
  height: auto;
  padding-top: 100%;
  border: 2px dashed #a7a8aa;
  filter: alpha(opacity=60);
  filter: alpha(opacity=60);
  opacity: 0.6;
  z-index: 3;
  bottom: 10px;
  right: 10px;
}
.leadership-name {
  color: #2a3997;
  font-size: 30px;
  text-align: center;
  padding-top: 25px;
}
.leadership-designation {
  color: #242424;
  font-size: 20px;
  font-weight: 300;
  text-align: center;
}
.grey-circle {
  position: absolute;
  bottom: 0;
  border-radius: 50%;
  width: 100%;
  height: auto;
  padding-top: 100%;
  background-color: #fff;
}
.learship-container {
  transition: all ease-in-out 0.5s;
}
.learship-container:hover {
  transform: scale(1.05, 1.05);
}
@media only screen and (max-width: 768px) {
  .content-title {
    font-size: 14px;
  }
  .content-sub-title {
    font-size: 16px;
    line-height: 16px;
  }

  h3 {
    font-size: 14px;
  }
  .leadership-name {
    font-size: 16px;
    padding-top: 25px;
  }
  .leadership-designation {
    font-size: 14px;
    min-height: inherit;
  }
  .red-button {
    margin-top: 20px;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    font-size: 16px;
  }
}
</style>
<script>
import Partners from "./Partners.ts";
export default Partners;
</script>